import { render, staticRenderFns } from "./PageEmailConfirmCode.vue?vue&type=template&id=6293f29b&"
import script from "./PageEmailConfirmCode.vue?vue&type=script&lang=ts&"
export * from "./PageEmailConfirmCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports